import React, { useState, useEffect } from "react";
import {
  MapPin,
  DollarSign,
  ArrowRight,
  Grid,
  Menu,
  User,
} from "react-feather";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Parser from "html-react-parser";

import "react-rangeslider/lib/index.css";

import "react-awesome-slider/dist/styles.css";
// import image from "../../";
// import image2 from "../../assets/profile/job-openings1.jpg";
import ListViewCard from "../../Components/ListViewCard";
import { Col, Row, UncontrolledCarousel } from "reactstrap";
import Notiflix from "notiflix";
import GetApiCall from "../../Api/GetApi";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import robot from "../../assets/profile/9318694-removebg-preview.png";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import CommonModal from "../../Components/CommonModal";
import PostApiCall from "../../Api/Api";
import { useSelector } from "react-redux";
import FilterComponent from "./FilterComponent";
import { BANNER_BG, PRIMARY_COLOR } from "../../color";
import { useRef } from "react";
const JobOpening = () => {

  const [filteredJobs, setFilteredJobs] = useState([]);
  const { location } = useHistory();
  const [IsSearch, setIsSearch] = useState(location?.state?.filter?true:false);
  const user = useSelector((state) => state.login);



  useEffect(() => {
    fetchJobList();
    if (location?.state?.filter) {
      setIsSearch(true);
      handleFilterChange(location?.state?.filter);
    }
  }, [location]);

  function convertFilterToSQL(filter) {
    let conditions = [];

    // Loop through the filter object
    for (let key in filter) {
      if (filter.hasOwnProperty(key)) {
        let filterValue = filter[key];

        // Check if the key is related to a max value (e.g., fld_maxsalary, fld_maxage)
        if (key.includes("max") && typeof filterValue !== "object") {
          conditions.push(`${key} <= ${filterValue}`);
        }
        // Handle range conditions like min/max together (e.g., salary between min and max)
        else if (typeof filterValue === "object" && filterValue !== null) {
          if (filterValue.max !== undefined) {
            conditions.push(`${key}<= ${filterValue.max}`);
          }
        }
        // If the value is a string, replace spaces with '%'
        else if (typeof filterValue === "string") {
          filterValue = filterValue.replace(/ /g, "%"); // Replace spaces with '%'
          conditions.push(`${key} LIKE '%${filterValue}%'`);
        } else {
          // For numbers or other types, just use the value directly without modification
          conditions.push(`${key} = ${filterValue}`);
        }
      }
    }

    // Join all conditions with 'AND' and return the result
    return conditions.length > 0
      ? conditions.join(IsSearch ? " OR " : " AND ")
      : "";
  }

  const fetchJobList = async (filtervalue) => {
    Notiflix.Loading.standard();
    try {
      let sqlCondition = await convertFilterToSQL(filtervalue);
      const payload = {
        usertype: user ? user.fld_usertype : "Seeker",
        filter: sqlCondition,
      };

      const json = await PostApiCall.postRequest(payload, "GetAllJobOpening");
      const res = await json.json();
      if (json.status === 200 || json.status === 201) {
        
        setFilteredJobs(res?.data || []);
      } else {
        toast.error(res?.data, {
          autoClose: delay,
          toastId: 1,
        });
      }
    } catch (error) {
      toast.error(SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    }
    Notiflix.Loading.remove();
  };

  const showDetailHandler = (data) => {
    window.open(
      `/jobdetails/${data?.fld_id}/${data?.fld_title?.replace(/\W|_/g, "")}`,
      "_blank"
    ); // Open in a new tab
    // history.push({
    //   pathname: `/jobdetails/${data?.fld_id}/${data?.fld_title?.replace(
    //     /\W|_/g,
    //     ""
    //   )}`,
    //   state: data?.fld_id,
    // });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFilterChange = (updatedFilters) => {
    // setFilters(updatedFilters);
    const filteredParams = Object.fromEntries(
      Object.entries(updatedFilters).filter(
        ([_, value]) => value !== "" && value != 0
      )
    );

    fetchJobList(filteredParams);
  };

  const filters = [
    {
      name: "fld_title",
      label: "Search",
      type: "text",
      col: 3,
      defaultValue: "",
      placeholder: "Keyword,Title",
    },
    {
      name: "fld_city",
      label: "Location",
      type: "text",
      col: 3,
      defaultValue: "",
      placeholder: "City , State",
    },
    {
      name: "fld_maxexperience",
      label: "Experience",
      type: "number",
      col: 3,
      defaultValue: "",
      placeholder: "(in years)",
    },
    {
      name: "fld_maxsalary",
      label: "Salary",
      type: "range",
      col: 3,
      defaultValue: '0',
      placeholder: "Salary",
    },
    {
      name: "fld_type",
      label: "Job Type",
      type: "select",
      options: [
        { value: "", label: "All" },
        { value: "Part time", label: "Part time" },
        { value: "Full time", label: "Full time" },
      ],
      col: 3,
      defaultValue: "",
      placeholder: "Select Type",
    },
  ];

  return (
    <div className="App ">
      <header
        id="home"
        className="hero-area"
        style={{ backgroundColor: BANNER_BG }}
      >
        <div className="container">
          <div className="row space-100">
            <div className="col-lg-5 col-md-12 col-xs-12 md-order-0 order-1">
              <div className="intro-img">
                <img src="/assets/img/slider/img-3.png" alt="" />
              </div>
            </div>
            <div className="col-lg-7 col-md-12 col-xs-12 md-order-1 order-0">
              <div className="contents">
                <h1
                  className="display-6 fw-bold mb-3"
                  style={{ color: PRIMARY_COLOR }}
                  // style={{ fontSize: "50px", lineHeight: "4rem" }}
                >
                  Wake Up To A Better Future
                </h1>
                <p
                  className="text-dark"
                  style={{ fontSize: "30px", lineHeight: "2rem" }}
                >
                  One Step To Your Future Starts Here !!!
                </p>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div
        className="py-4 px-2 d-flex justify-content-center "
        style={{ backgroundColor: "rgb(201 201 213 / 3%)" }}
      >
        <h6 className=" headingMainStyle">
          <span>JOB OPENING</span>
        </h6>
      </div>
      <Row
        className=" p-3 px-md-5 "
        style={{ backgroundColor: "rgb(201 201 213 / 3%)" }}
      >
        <Col></Col>
        <Col lg={9} sm={12}></Col>
        <Col></Col>
      </Row>

      <Row
        className=" p-3 px-md-5 mb-4"
        id="featured"
        style={{ backgroundColor: "rgb(201 201 213 / 3%)" }}
      >
        <Col>
          <FilterComponent
            filters={filters}
            onFilterChange={handleFilterChange}
            setIsSearch={setIsSearch}
          />
        </Col>
        <Col lg={9} sm={12}>
          {filteredJobs?.length > 0 ? (
            <Row className="">
              {filteredJobs?.map((job, index) => (
                <Col lg={4} md={4} sm={6} className="jobCard" key={index}>
                  <div className="job-featured" style={{ minHeight: "300px" }}>
                    <div className="content p-1  bg-white rounded-4 feature-cardOne-adjustments">
                      <h3 className="text-truncate">
                        <a>{job.fld_title}</a>
                      </h3>
                      <ul className="list-unstyled mt-3 mb-1 card-tag-list">
                        <li>
                          <a
                            className="BlueWhite font-size-2  rounded-3"
                            href="/#"
                          >
                            <MapPin size={13} className="mr-1" /> {job.fld_city}
                          </a>
                        </li>
                        <li>
                          <a
                            className="LightBlueWhite font-size-2 rounded-3"
                            href="/#"
                          >
                            {job.fld_positions} Position
                          </a>
                        </li>
                        {/* {job.fld_maxsalary !== null && (
                          <li>
                            <a
                              className="GreenWhite text-eastern font-size-2 rounded-3"
                              href="/#"
                            >
                              ₹ {kFormatter(job.fld_minsalary)} -{" "}
                              {kFormatter(job.fld_maxsalary)}
                            </a>
                          </li>
                        )} */}
                        <li>
                          <a
                            className="OrangeWhite text-eastern font-size-2 rounded-3"
                            href="/#"
                          >
                            {job.fld_type}
                          </a>
                        </li>
                      </ul>
                      <p
                        className="mb-7 font-size-3 text-gray text-clip"
                        style={{ height: "100px" }}
                      >
                        {Parser(
                          job?.fld_jobdescription
                            ?.replace(/font-family/g, "")
                            ?.replace(/<p>/g, "")
                        )}
                      </p>
                      <div className="col-12 btn-det-right">
                        <span
                          className="btn-det btn-common-det"
                          style={{ cursor: "pointer" }}
                          onClick={() => showDetailHandler(job)}
                        >
                          Job Details <ArrowRight size={15} />{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          ) : (
            <div className="m-auto">
              <p className="w-50 mx-auto">
                <img src={robot} width={"100%"} height={"100%"} />
              </p>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

// const filtered = jobsData.filter((job) => {
//   const keywordMatch = updatedFilters.keyword
//   ? [job.fld_title, job.fld_city, job.fld_state].some((field) =>
//       field.toLowerCase().includes(updatedFilters.keyword.toLowerCase())
//     )
//   : true;
//   const experienceMatch = updatedFilters.experience
//     ? job.fld_maxexperience >= parseInt(updatedFilters.experience, 10)
//     : true;
//   const salaryMatch = updatedFilters.salary
//     ? job.fld_minsalary <= parseInt(updatedFilters.salary, 10) &&
//       (job.fld_maxsalary === null ||
//         job.fld_maxsalary >= parseInt(updatedFilters.salary, 10))
//     : true;

//   const typeMatch =
//     updatedFilters.type === "All" || !updatedFilters.type
//       ? true // Show all if "All" is selected or no type is specified
//       : job.fld_type === updatedFilters.type;

//   return keywordMatch && experienceMatch && salaryMatch && typeMatch;
// });

// setFilteredJobs(filtered);

export default JobOpening;
